// Packages
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// components
import HeaderStep from "./HeaderStep";

// utils
import { noDigitalFlowSteps, digitalFlowSteps } from "../utils/CheckStep";

const Header = (props) => {
  const { t } = useTranslation();
  const { information, shipping, colors, urls } = useSelector(
    (state) => state.checkoutStore,
  );
  const currentPage = parseInt(props.page, 10);
  const shippingIndex = noDigitalFlowSteps.indexOf("shipping");
  const billingAndPaymentIndex =
    information.no_shipping_required ||
    information.shipping_option === "store_pickup"
      ? digitalFlowSteps.indexOf("billing")
      : noDigitalFlowSteps.indexOf("billing");

  const getBorderColor = (currentPage, index) => {
    return currentPage > index ? colors.main_color : `${colors.text_color}CC`;
  };

  const AllHeaders = (
    <div className="links col-12 mb-1">
      <HeaderStep
        currentPage={currentPage}
        url={urls.information}
        isDisabled={false}
        currentIndex={0}
        colors={colors}
        text={t("header.information")}
        classLabel={"first"}
      />
      <div className="link-line-div link-w-50">
        <div
          className="link-line"
          style={{
            borderColor: getBorderColor(currentPage, shippingIndex),
          }}
        ></div>
      </div>
      <HeaderStep
        currentPage={currentPage}
        url={urls.shipping}
        isDisabled={Object.keys(information).length === 0}
        currentIndex={shippingIndex}
        colors={colors}
        text={t("header.shipping")}
      />
      <div className="link-line-div link-w-50">
        <div
          className="link-line"
          style={{
            borderColor: getBorderColor(currentPage, billingAndPaymentIndex),
          }}
        ></div>
      </div>
      <HeaderStep
        currentPage={currentPage}
        url={urls.billing}
        isDisabled={
          Object.keys(information).length === 0 ||
          Object.keys(shipping).length === 0
        }
        currentIndex={billingAndPaymentIndex}
        colors={colors}
        text={t("header.payment")}
        classLabel={"last"}
      />
    </div>
  );

  const DigitalHeaders = (
    <div className="links col-12 mb-1 ">
      <HeaderStep
        currentPage={currentPage}
        url={"/v2/checkout/information/" + window.token}
        isDisabled={false}
        currentIndex={0}
        colors={colors}
        text={t("header.information")}
        classLabel={"first"}
      />
      <div className="link-line-div link-w-100">
        <div
          className="link-line"
          style={{
            borderColor: getBorderColor(currentPage, billingAndPaymentIndex),
          }}
        ></div>
      </div>
      <HeaderStep
        currentPage={currentPage}
        url="/v2/checkout/billing"
        isDisabled={Object.keys(information).length === 0}
        currentIndex={billingAndPaymentIndex}
        colors={colors}
        text={t("header.payment")}
        classLabel={"last"}
      />
    </div>
  );

  const PickupHeaders = (
    <div className="links col-12 mb-1 ">
      <HeaderStep
        currentPage={currentPage}
        url={"/v2/checkout/information/" + window.token}
        isDisabled={false}
        currentIndex={0}
        colors={colors}
        text={t("header.information")}
        classLabel={"first"}
      />
      <div className="link-line-div link-w-100">
        <div
          className="link-line"
          style={{
            borderColor: getBorderColor(currentPage, billingAndPaymentIndex),
          }}
        ></div>
      </div>
      <HeaderStep
        currentPage={currentPage}
        url="/v2/checkout/billing"
        isDisabled={Object.keys(information).length === 0}
        currentIndex={1}
        colors={colors}
        text={t("header.payment")}
        classLabel={"last"}
      />
    </div>
  );

  return (
    <Fragment>
      {information.no_shipping_required
        ? DigitalHeaders
        : information.shipping_option === "store_pickup" ||
            information.shipping_option === "point_pickup"
          ? PickupHeaders
          : AllHeaders}
    </Fragment>
  );
};

export default Header;
